export type AdminToastType = 'success' | 'error' | 'warning';

export interface AdminToastState {
    show: boolean;
    message: string;
    type: AdminToastType;
}

export const emptyAdminToast: AdminToastState = {
    show: false,
    message: '',
    type: 'success',
};

export function clearAdminToastTimer(timerRef: { current: number | null }): void {
    if (timerRef.current !== null) {
        window.clearTimeout(timerRef.current);
        timerRef.current = null;
    }
}
